import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core'
import { UserAccountsFacade } from 'libs/gb-dashboard/staff/data-access-user-accounts/src/lib/+state/user-accounts.facade'
import * as UserAccountsActions from 'libs/gb-dashboard/staff/data-access-user-accounts/src/lib/+state/user-accounts.actions'
import { map } from 'rxjs'

@Component({
  selector: 'gb-archive-user-dialog',
  templateUrl: './gb-archive-user-dialog.component.html',
  styleUrls: ['./gb-archive-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbArchiveUserDialogComponent implements OnDestroy {
  selectedUserAccount$ = this.userAccountsFacade.selectedUserAccount$
  saved$ = this.userAccountsFacade.saving$.pipe(map((saving) => !saving))

  bullets = [
    'USER_ACCOUNTS.ARCHIVE_DIALOG.BULLETS.NAME_CHANGED',
    'USER_ACCOUNTS.ARCHIVE_DIALOG.BULLETS.CONTACT_REMOVED',
    'USER_ACCOUNTS.ARCHIVE_DIALOG.BULLETS.ACCESS_REVOKED',
    'USER_ACCOUNTS.ARCHIVE_DIALOG.BULLETS.HIGHEST_BID',
  ]

  constructor(private userAccountsFacade: UserAccountsFacade) {}

  ngOnDestroy(): void {
    this.userAccountsFacade.dispatch(UserAccountsActions.clearSelectedId())
  }

  archiveUser(): void {
    this.userAccountsFacade.dispatch(UserAccountsActions.archiveUser())
  }
}
